import React, {Component, PropTypes} from 'react'
import {OverlayTrigger} from './overlay_trigger'
import {DropdownMenu} from './dropdown_menu'
import cx from 'classnames'

export class Dropdown extends Component {
  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  forceClose() {
    this._overlay.forceClose()
  }

  render() {
    return (
      <OverlayTrigger
        {...this.props}
        ref={(r) => this._overlay = r}
        className={cx('dropdown', this.props.className)}
        component={DropdownMenu}
        rootClose
        placement='bottom'
      >
        {this.props.children}
      </OverlayTrigger>
    )
  }
}
